window.REVIEW_DATA = {

    // ==========================================================
    // Reviewer Names
    // ==========================================================
    names: [

        "Mahak",
        "Ankur",
        "Priya",
        "Rahul",
        "Neha",
        "Sneha",
        "Rohit",
        "Pooja",
        "Vikas",
        "Amit",
        "Riya",

        "Simran",
        "Karan",
        "Anjali",
        "Nisha",
        "Deepak",
        "Megha",
        "Arjun",
        "Sonia",
        "Komal",
        "Harsh",

        "Aakash",
        "Nitin",
        "Payal",
        "Kavita",
        "Divya",
        "Varun",
        "Abhishek",
        "Shreya",
        "Tanvi",
        "Rakesh",

        "Gaurav",
        "Ritu",
        "Naveen",
        "Sakshi",
        "Ayushi",
        "Rohini",
        "Aditya",
        "Saurabh",
        "Manish",
        "Muskan",

        "Rohan",
        "Anita",
        "Vinay",
        "Swati",
        "Mohit",
        "Reena",
        "Ashish",
        "Jyoti",
        "Kriti",
        "Aarav",

        "Aditi",
        "Aishwarya",
        "Ajith",
        "Akash",
        "Aman",
        "Ananya",
        "Anirban",
        "Ankita",
        "Anoop",
        "Anusha",
        "Arindam",
        "Arun",
        "Arya",
        "Asha",
        "Athira",
        "Bikash",
        "Darshan",
        "Debjit",
        "Deepa",
        "Devika",
        "Dhruv",
        "Dipankar",
        "Gauri",
        "Gurleen",
        "Harini",
        "Harjit",
        "Harleen",
        "Hemant",
        "Hetal",
        "Himanshu",
        "Jasdeep",
        "Jaspreet",
        "Jay",
        "Jinal",
        "Jonali",
        "Kavitha",
        "Kavya",
        "Keerthana",
        "Khushi",
        "Krupa",
        "Lakshmi",
        "Lokesh",
        "Madhumita",
        "Mahesh",
        "Manoj",
        "Manpreet",
        "Meera",
        "Mira",
        "Meet",
        "Mitali",
        "Monalisa",
        "Mouli",
        "Mrinmoyee",
        "Nandhini",
        "Nandni",
        "Navnit",
        "Navneet",
        "Nivin",
        "Pallabi",
        "Pallavi",
        "Parwai",
        "Parvathy",
        "Pavithra",
        "Puja",
        "Pravin",
        "Praveen",
        "Rimjhim",
        "Ritika",
        "Rituraj",
        "Rupa",
        "Rituja",
        "Rutuja",
        "Sagar",
        "Santosh",
        "Sijin",
        "Snehal",
        "Soma",
        "Sourabh",
        "Sourav",
        "Sreeja",
        "Subho",
        "Suresh",
        "Swapnil",
        "Vaishnavi",
        "Vignesh",
        "Mohini"

    ],
        // ==========================================================
        // Reviewer Last Names
        // ==========================================================

        lastNames: [

        "Banerjee",
        "Bhat",
        "Borah",
        "Boro",
        "Bose",
        "Brar",
        "Chatterjee",
        "Choudhary",
        "Chaudhary",
        "Das",
        "Desai",
        "Deshmukh",
        "Dutta",
        "Gill",
        "Gogoi",
        "Gowda",
        "Gupta",
        "Hegde",
        "Iyengar",
        "Iyer",
        "Jain",
        "Joshi",
        "Kaur",
        "Krishnan",
        "Kulkarni",
        "Kurup",
        "Mehta",
        "Menon",
        "Mishra",
        "Mukherjee",
        "Nair",
        "Pandey",
        "Patel",
        "Patil",
        "Pawar",
        "Pillai",
        "Raman",
        "Rao",
        "Saikia",
        "Sandhu",
        "Shah",
        "Sharma",
        "Shetty",
        "Shinde",
        "Sidhu",
        "Singh",
        "Soni",
        "Subramanian",
        "Tiwari",
        "Trivedi",
        "Varma",
        "Yadav",
        "Verma",
        "Kumar",
        "Agrawal",
        "Sinha",
        "Srivastava",
        "Saxena",
        "Tripathi",
        "Chaturvedi",
        "Chauhan",
        "Rathore",
        "Tomar",
        "Thakur",
        "Bansal",
        "Goyal",
        "Mahajan",
        "Arora",
        "Malhotra",
        "Khanna",
        "Kapoor",
        "Bhardwaj",
        "Vora",
        "Parekh",
        "Bhatt",
        "Dave",
        "Modi",
        "Panchal",
        "Solanki",
        "Parmar",
        "Chavda",
        "Reddy",
        "Naidu",
        "Acharya",
        "Kamath",
        "Ghosh",
        "Roy",
        "Sen",
        "Pal",
        "Kar",
        "Biswas",
        "Dhillon",
        "Mann",
        "Bajwa",
        "Aulakh",
        "Virk",
        "Grewal",
        "Pannu",
        "Chahal"
        ],
    // ==========================================================
    // Cities
    // ==========================================================
    cities: [

        "Itanagar",
        "Naharlagun",
        "Pasighat",
        "Tawang",
        "Nagaon",
        "Jagdalpur",
        "Panaji",
        "Margao",
        "Vasco da Gama",
        "Mapusa",
        "Gurugram",
        "Dharamshala",
        "Solan",
        "Mandi",
        "Kullu",
        "Hazaribagh",
        "Mysuru",
        "Kannur",
        "Thoubal",
        "Bishnupur",
        "Shillong",
        "Tura",
        "Lunglei",
        "Kohima",
        "Dimapur",
        "Mokokchung",
        "Mohali",
        "Gangtok",
        "Namchi",
        "Gyalshing",
        "Dharmanagar",
        "Noida",
        "Haldwani",
        "Rishikesh",
        "Roorkee",
        "Andhra Pradesh",
        "Arunachal Pradesh",
        "Belagavi",
        "Bihar",
        "Chhattisgarh",
        "Dibrugarh",
        "Goa",
        "Haryana",
        "Himachal Pradesh",
        "Hubballi",
        "Jammu & Kashmir",
        "J & K",
        "Jharkhand",
        "Jorhat",
        "Madhya Pradesh",
        "Mangaluru",
        "Manipur",
        "Meghalaya",
        "Mizoram",
        "Nagaland",
        "Odisha",
        "Sikkim",
        "Telangana",
        "Tezpur",
        "Tripura",
        "Uttarakhand",
        "Achalpur",
        "Adityapur",
        "Adoni",
        "Agartala",
        "Agra",
        "Ahilyanagar",
        "Ahmedabad",
        "Aizawl",
        "Ajmer",
        "Akola",
        "Alandur",
        "Alappuzha",
        "Aligarh",
        "Alwar",
        "Amaravati",
        "Ambala",
        "Ambarnath",
        "Ambattur",
        "Amravati",
        "Amritsar",
        "Amroha",
        "Anand",
        "Anantapur",
        "Arrah",
        "Asansol",
        "Aurangabad",
        "Avadi",
        "Badlapur",
        "Bagaha",
        "Bahadurgarh",
        "Baharampur",
        "Bahraich",
        "Bally",
        "Baranagar",
        "Barasat",
        "Bardhaman",
        "Bareilly",
        "Barshi",
        "Batala",
        "Bathinda",
        "Beed",
        "Begusarai",
        "Belgaum",
        "Bellary",
        "Bengaluru",
        "Berhampur",
        "Bettiah",
        "Bhagalpur",
        "Bhalswa Jahangir Pur",
        "Bharatpur",
        "Bharuch",
        "Bhatpara",
        "Bhavnagar",
        "Bhilai",
        "Bhilwara",
        "Bhimavaram",
        "Bhind",
        "Bhiwandi",
        "Bhiwani",
        "Bhopal",
        "Bhubaneswar",
        "Bhusawal",
        "Bidar",
        "Bidhan Nagar",
        "Bihar Sharif",
        "Bijapur",
        "Bikaner",
        "Bilaspur",
        "Bokaro",
        "Budaun",
        "Bulandshahr",
        "Burhanpur",
        "Buxar",
        "Chandannagar",
        "Chandigarh",
        "Chandrapur",
        "Chapra",
        "Chennai",
        "Chhatrapati Sambhajinagar",
        "Chittoor",
        "Coimbatore",
        "Cuddalore",
        "Cuttack",
        "Danapur",
        "Darbhanga",
        "Davanagere",
        "Dehradun",
        "Dehri",
        "Delhi",
        "Deoghar",
        "Deoli",
        "Dewas",
        "Dhanbad",
        "Dharmavaram",
        "Dhule",
        "Dindigul",
        "Durg",
        "Durgapur",
        "Eluru",
        "Erode",
        "Etawah",
        "Faizabad",
        "Faridabad",
        "Farrukhabad",
        "Fatehpur",
        "Firozabad",
        "Gadag-Betageri",
        "Gandhidham",
        "Gandhinagar",
        "Gaya",
        "Ghaziabad",
        "Gondia",
        "Gopalpur",
        "Gorakhpur",
        "Greater Noida",
        "Gudivada",
        "Guna",
        "Guntakal",
        "Guntur",
        "Gurgaon",
        "Guwahati",
        "Gwalior",
        "Hajipur",
        "Haldia",
        "Haldwani—Kathgodam",
        "Hapur",
        "Haridwar",
        "Hastsal",
        "Hindupur",
        "Hinganghat",
        "Hisar",
        "Hoshiarpur",
        "Hospet",
        "Howrah",
        "Hubli–Dharwad",
        "Hugli-Chuchura",
        "Hyderabad",
        "Ichalkaranji",
        "Imphal",
        "Indore",
        "Jabalpur",
        "Jaipur",
        "Jalandhar",
        "Jalgaon",
        "Jalna",
        "Jamalpur",
        "Jammu",
        "Jamnagar",
        "Jamshedpur",
        "Jaunpur",
        "Jehanabad",
        "Jhansi",
        "Jind",
        "Jodhpur",
        "Junagadh",
        "Kadapa",
        "Kakinada",
        "Kalaburagi",
        "Kalyan-Dombivli",
        "Kamarhati",
        "Kancheepuram",
        "Kanpur",
        "Karaikudi",
        "Karawal Nagar",
        "Karimnagar",
        "Karnal",
        "Katihar",
        "Kavali",
        "Khammam",
        "Khandwa",
        "Kharagpur",
        "Khora",
        "Kirari Suleman Nagar",
        "Kishanganj",
        "Kishangarh",
        "Kochi",
        "Kolhapur",
        "Kolkata",
        "Kollam",
        "Korba",
        "Kota",
        "Kozhikode",
        "Kulti",
        "Kurnool",
        "Latur",
        "Loni",
        "Lucknow",
        "Ludhiana",
        "Machilipatnam",
        "Madanapalle",
        "Madhyamgram",
        "Madurai",
        "Mahbubnagar",
        "Mahesana",
        "Maheshtala",
        "Malda",
        "Malegaon",
        "Mangalore",
        "Mango",
        "Mathura",
        "Maunath Bhanjan",
        "Medinipur",
        "Meerut",
        "Mira-Bhayandar",
        "Miryalaguda",
        "Mirzapur",
        "Moradabad",
        "Morena",
        "Morvi",
        "Motihari",
        "Mumbai",
        "Munger",
        "Murwara",
        "Muzaffarnagar",
        "Muzaffarpur",
        "Mysore",
        "Nadiad",
        "Nagercoil",
        "Nagpur",
        "Naihati",
        "Nanded Waghala",
        "Nandurbar",
        "Nandyal",
        "Nangloi Jat",
        "Narasaraopet",
        "Nashik",
        "Navi Mumbai",
        "Navsari",
        "Nellore",
        "New Delhi",
        "Nizamabad",
        "Noida (town)",
        "North Dumdum",
        "Ongole",
        "Orai",
        "Osmanabad",
        "Ozhukarai",
        "Pali",
        "Pallavaram",
        "Panchkula",
        "Panihati",
        "Panipat",
        "Panvel",
        "Parbhani",
        "Patiala",
        "Patna",
        "Pimpri-Chinchwad",
        "Prayagraj",
        "Proddatur",
        "Puducherry",
        "Pune",
        "Puri",
        "Purnia",
        "Raebareli",
        "Raichur",
        "Raiganj",
        "Raipur",
        "Rajahmundry",
        "Rajkot",
        "Rajnandgaon",
        "Rajpur Sonarpur",
        "Ramagundam",
        "Rampur",
        "Ranchi",
        "Ratlam",
        "Raurkela Industrial Township",
        "Rewa",
        "Rohtak",
        "Rourkela",
        "Sagar",
        "Saharanpur",
        "Saharsa",
        "Salem",
        "Sambalpur",
        "Sambhal",
        "Sangli-Miraj & Kupwad",
        "Sasaram",
        "Satara",
        "Satna",
        "Secunderabad",
        "Serampore",
        "Shahjahanpur",
        "Shimla",
        "Shivamogga",
        "Shivpuri",
        "Sikar",
        "Silchar",
        "Siliguri",
        "Singrauli",
        "Sirsa",
        "Sitapur",
        "Siwan",
        "Solapur",
        "Sonipat",
        "South Dumdum",
        "Sri Ganganagar",
        "Srikakulam",
        "Srinagar",
        "Sultan Pur Majra",
        "Surat",
        "Surendranagar Dudhrej",
        "Suryapet",
        "Tadepalligudem",
        "Tadipatri",
        "Tambaram",
        "Tenali",
        "Thane",
        "Thanesar",
        "Thanjavur",
        "Thiruvananthapuram",
        "Thoothukudi",
        "Thrissur",
        "Tiruchirappalli",
        "Tirunelveli",
        "Tirupati",
        "Tiruppur",
        "Tiruvottiyur",
        "Tonk",
        "Tumkur",
        "Udaipur",
        "Udgir",
        "Ujjain",
        "Ulhasnagar",
        "Uluberia",
        "Unnao",
        "Uttarpara Kotrung",
        "Vadodara",
        "Vapi",
        "Varanasi",
        "Vasai-Virar",
        "Vellore",
        "Veraval",
        "Vidisha",
        "Vijayanagaram",
        "Vijayawada",
        "Visakhapatnam",
        "Warangal",
        "Wardha",
        "Yamunanagar",
        "Yavatmal",
        "Leh",
        "Kargil",
        "Karaikal",
        "Mahe",
        "Yanam",
        "Port Blair",
        "Daman",
        "Diu",
        "Silvassa",
        "Kavaratti",

    ],

    // ==========================================================
    // Relative Dates
    // ==========================================================
    dates: [

        "2 days ago",
        "3 days ago",
        "5 days ago",
        "1 week ago",
        "2 weeks ago",
        "3 weeks ago",
        "1 month ago",
        "5 days ago",
        "4 days ago",
        "6 days ago"

    ],

    // ==========================================================
    // Ratings
    // ==========================================================
    ratings: [

        5,
        4,
        3,
        2,
        1,
        3,
        5,
        2,
        5,
        4

    ],
    // ==========================================================
    // Negative Review Library
    // ==========================================================

    negativeReviews: [

    // ---------- 2 Star ----------

    {
        severity: 2,
        text: "Product okay okay hai. Thoda disappoint hu."
    },

    {
        severity: 2,
        text: "Expectation zyada thi. Quality improve honi chahiye."
    },

    {
        severity: 2,
        text: "Kaam chal jayega. Looks different. Packaging weak thi."
    },

    {
        severity: 2,
        text: "Packaging damaged. Packing could have been better. Expected more."
    },

    {
        severity: 2,
        text: "Quality is okay but expected better."
    },

    {
        severity: 2,
        text: "Item average nikla. Thoda costly laga."
    },

    {
        severity: 2,
        text: "Size is smaller than expected. Packing could have been better."
    },

    {
        severity: 2,
        text: "Item is good, but delivery was late."
    },

    {
        severity: 2,
        text: "Color quite looks different, but quality is premium. Worth the price."
    },

    {
        severity: 2,
        text: "Material is OK, feels average. Expected better quality. But satisfied with the product."
    },
    {
        severity: 2,
        text: "Some items were damaged, but easily replaced by the Beadsnfashion."
    },
    {
        severity: 2,
        text: "Packaging was quite poor. Thought it would be better."
    },
    {
        severity: 2,
        text: "Works but quality is average."
    },
    {
        severity: 2,
        text: "Not very happy as Delivery took too long."
    },
    {
        severity: 2,
        text: "Expected premium quality. Could be better."
    },
    {
        severity: 2,
        text: "Received different shade. So I ordered it again"
    },
    {
        severity: 2,
        text: "Average packing. Slightly disappointed."
    },
    {
        severity: 2,
        text: "Not bad, not great. Photo looked better."
    },
    {
        severity: 2,
        text: "Average finishing. Product feels light."
    },

    // ---------- 1 Star ----------

    {
        severity: 1,
        text: "Could improve quality. Average overall."
    },

    {
        severity: 1,
        text: "Thik hai bas. Quality utni achhi nahi lagi."
    },

    {
        severity: 1,
        text: "Photo se alag hai aur Packing normal thi."
    },

    {
        severity: 1,
        text: "Delivery late mili. Paisa vasool nahi laga."
    },

    {
        severity: 1,
        text: "Thoda better ho sakta tha. Bas theek hai."
    },

    {
        severity: 1,
        text: "Average product. Use kar sakte hain."
    },

    {
        severity: 1,
        text: "Utna pasand nahi aaya kyu ki Color alag nikla."
    },

    {
        severity: 1,
        text: "Size chhota hai. Material average hai. Finish achhi nahi hai."
    },

    {
        severity: 1,
        text: "Expected something better. Quality normal hai."
    },

    {
        severity: 1,
        text: "Thoda aur achha hota. Okay product."
    },

    {
        severity: 1,
        text: "Average finishing. Design expected jaisa nahi."
    },

    {
        severity: 1,
        text: "Looks ordinary. Mixed experience."
    },

    {
        severity: 1,
        text: "Could be improved. Received late. "
    },

    {
        severity: 1,
        text: "Color utna achha nahi. Okay but not great."
    },

    {
        severity: 1,
        text: "Need improvement. Didn't meet expectations. Expected more for this price."
    },

    {
        severity: 1,
        text: "Average purchase. Bas chal jayega."
    }

    ],
    // ==========================================================
    // Business Owner Reviews
    // ==========================================================
               
    // ==========================================================
    // Verified Badge
    // ==========================================================
    verified: [

        "Verified Buyer"

    ],

    // ==========================================================
    // Review Templates
    // {product} will be replaced automatically.
    // ==========================================================
    longEnglishReviews: [

    "I've been making handmade jewellery for quite some time, and this purchase genuinely impressed me. The quality is consistent, the finish is clean, and everything worked exactly as expected. I'll definitely be buying again in the future.",

    "This was my first order from this store, and I'm extremely satisfied with the overall experience. The quality exceeded my expectations, and every piece looked professionally finished. Highly recommended to anyone who enjoys crafting.",

    "I've tried similar products from several different suppliers, but this one stands out because of its consistent quality and attention to detail. Everything arrived safely packed and was ready to use immediately. Great experience overall.",

    "The material feels premium and is very easy to work with. I was able to complete several jewellery designs without any issues, and the final results looked beautiful. Definitely worth purchasing.",

    "I'm genuinely happy with this purchase. The quality remained consistent throughout the entire pack, and the finished jewellery received many compliments from my customers. Looking forward to placing another order."
    ],
    longHindiReviews: [
    "इस खरीदारी से अच्छा अनुभव रहा। क्वालिटी शानदार है और हर चीज़ अच्छे से तैयार की गई है। जितनी उम्मीद थी, उससे बेहतर निकला।",

    "काफी समय बाद इतनी अच्छी क्वालिटी का सामान मिला। फिनिश भी बढ़िया है और इस्तेमाल करना आसान लगा। खरीदकर अच्छा लगा।",

    "क्वालिटी और पैकिंग दोनों बहुत अच्छी लगी। हर पीस अच्छे से तैयार किया गया है और देखने में भी बढ़िया है। दोबारा लेने लायक है।",

    "ज्वेलरी बनाने के लिए इस्तेमाल किया। हर पीस की क्वालिटी एक जैसी मिली और कोई दिक्कत नहीं हुई। अच्छा अनुभव रहा।",

    "दाम के हिसाब से क्वालिटी बहुत अच्छी है। सामान समय पर मिला और इस्तेमाल करने के बाद अच्छा लगा।",

    "सच कहूँ तो इतनी अच्छी क्वालिटी की उम्मीद नहीं थी। इस्तेमाल करने के बाद रिजल्ट भी अच्छा मिला।",

    "सब कुछ सही मिला। पैकिंग अच्छी थी, क्वालिटी भी बढ़िया थी और इस्तेमाल करने में कोई परेशानी नहीं हुई।",

    "पहली बार ऑर्डर किया था और अनुभव अच्छा रहा। सामान देखकर लगा कि सही जगह से लिया है।",

    "घर पर ज्वेलरी बनाने के लिए लिया था। रिजल्ट अच्छा आया और इस्तेमाल करना भी आसान लगा।",

    "क्वालिटी, फिनिश और पैकिंग तीनों अच्छी लगीं। उम्मीद से बेहतर निकला और पूरा अनुभव अच्छा रहा।"
    ],

    longHinglishReviews: [
    "Quality honestly expected se bhi better nikli. Finish kaafi clean hai aur use karne mein bhi bahut easy laga. Definitely next order bhi yahin se karunga.",

    "Mujhe overall experience bahut achha laga. Packing safe thi, quality premium feel hui aur final result bhi amazing aaya. Totally satisfied with the purchase.",

    "Is price range mein itni achhi quality milna difficult hota hai. Material strong hai aur finished jewellery ka look bhi kaafi premium aaya. Highly impressed.",

    "Main regular jewellery making karta hoon aur ye purchase kaafi useful rahi. Sab pieces proper finishing ke saath mile aur kisi bhi item mein koi issue nahi tha. Great experience overall.",

    "Honestly, ye meri best online purchases mein se ek hai. Quality consistent hai, finishing clean hai aur kaam karte waqt confidence milta hai. Future mein bhi isi store se order karunga."

    ],
    englishReviews: [

    "The product is of excellent quality and very easy to use. I am extremely satisfied with my purchase.",

    "I used the product for my handmade jewellery collection and the results were fantastic. Definitely buying again.",

    "The finishing of the product is outstanding. It gives a premium look to my designs.",

    "Received the product exactly as shown on the website. Very happy with the quality.",

    "The product worked perfectly for my DIY jewellery project. Highly satisfied with the purchase.",

    "Quality of the product is much better than expected. Great experience overall.",

    "The product arrived safely and every piece was in perfect condition. Excellent service.",

    "I've purchased similar products before, but this product is definitely one of the best.",

    "The shine and finish of the product are simply beautiful. Perfect for professional jewellery making.",

    "Very reliable quality. The product made my crafting work much easier.",

    "The product exceeded my expectations in terms of quality and appearance. Really impressed.",

    "I received exactly what I was looking for. The product is durable and well-made.",

    "The product looks elegant and feels premium. Great choice for jewellery designers.",

    "I loved working with the product. The quality is consistent throughout.",

    "Everything about the product is perfect, from the finish to the durability.",

    "The product is ideal for creating handmade accessories. Highly recommended.",

    "I am very pleased with the quality of the product. Worth every penny.",

    "The product has a smooth finish and beautiful appearance. Excellent craftsmanship.",

    "Very happy with this purchase. The product matches the description perfectly.",

    "The quality control is impressive. Every product piece looks flawless.",

    "The product helped me complete several customer orders with ease. Fantastic quality.",

    "I appreciate the premium finish of the product. It looks even better in person.",

    "The product fits perfectly into my jewellery designs. Very satisfied.",

    "Excellent material quality. The product is sturdy and attractive.",

    "The product gives a professional touch to handmade jewellery. Great purchase.",

    "I was pleasantly surprised by the quality of the product. Very reliable.",

    "The product is lightweight yet durable. Perfect combination for crafting.",

    "Beautifully finished product. My customers loved the final jewellery pieces.",

    "The product is easy to work with and looks fantastic after assembly.",

    "Exactly what every jewellery maker needs. The product is excellent.",

    "The quality of the product remained consistent throughout the pack. Very happy.",

    "The product is crafted with great attention to detail. Looks amazing.",

    "I've already recommended this product to my fellow jewellery makers.",

    "The product arrived on time and in excellent condition. Very satisfied.",

    "I used the product for multiple projects and every result was beautiful.",

    "Very good quality product. Perfect for beginners as well as professionals.",

    "The product has a clean finish with no defects. Excellent product.",

    "I appreciate the durability of the product. It feels long-lasting.",

    "The product is exactly what I needed for my handmade collection.",

    "Beautiful craftsmanship on the product. Really worth purchasing.",

    "The product blends perfectly with other jewellery components. Excellent quality.",

    "The finish of the product adds elegance to every design I create.",

    "I found the product easy to handle and assemble. Great experience.",

    "The product is one of the finest quality products I've purchased online.",

    "Very impressed with the appearance of the product. It looks premium.",

    "The product is suitable for both hobbyists and professional jewellery makers.",

    "Every product piece was clean, polished, and ready to use.",

    "The product gives a luxurious appearance without increasing the project cost.",

    "Excellent quality and fast delivery. The product met all my expectations.",

    "The product is beautifully finished and looks exactly like the product images.",

    "I couldn't be happier with the quality of the product. Great purchase.",

    "The product helped me create beautiful handmade gifts. Very satisfied.",

    "The material quality of the product is excellent for daily crafting.",

    "I've used the product several times now and the quality has remained consistent.",

    "The product offers outstanding value considering its premium finish.",

    "I am impressed by the smooth surface and attractive appearance of the product.",

    "The product is strong, reliable, and perfect for long-lasting jewellery.",

    "Everything about the product feels premium. Excellent buying experience.",

    "The product exceeded my expectations in every aspect. Highly satisfied.",

    "I received compliments from customers after using the product in my designs.",

    "The product is finished with great precision. Looks beautiful.",

    "Very practical and easy to use. The product made my work much simpler.",

    "The product has become one of my favourite jewellery-making supplies.",

    "The product gives every handmade creation a polished and professional finish.",

    "Very impressed with the packaging and quality of the product.",

    "The product is a great addition to my jewellery supplies collection.",

    "The quality of the product remained excellent even after frequent use.",

    "The product helped improve the overall appearance of my jewellery pieces.",

    "The product feels durable and reliable for everyday crafting.",

    "The design and finish of the product are truly impressive.",

    "The product looks classy and performs exactly as expected.",

    "I found the product very convenient for creating custom jewellery.",

    "The product has excellent detailing and beautiful finishing.",

    "I'll definitely continue purchasing this product for future projects.",

    "The product works wonderfully for handmade earrings and necklaces.",

    "The quality is consistent across every product piece in the pack.",

    "The product gives a premium look to my finished jewellery.",

    "I appreciate the neat finishing of the product. Very well made.",

    "The product has exceeded my expectations with its durability.",

    "The product is perfect for creative jewellery designs.",

    "I was impressed by the attention to detail on the product.",

    "The product feels sturdy and well-manufactured.",

    "The finish is clean and attractive. The product looks amazing.",

    "The product offers excellent quality for jewellery making enthusiasts.",

    "Very reliable product. It performed exactly as expected.",

    "The product is an excellent choice for handmade accessories.",

    "The appearance of the product is elegant and professional.",

    "The product fits beautifully into all my jewellery projects.",

    "The product quality is outstanding and the product is easy to use.",

    "I've already placed another order because the product exceeded my expectations.",

    "The product is beautifully crafted and worth every penny.",

    "Excellent quality with a professional finish. The product looks fantastic.",

    "The product is one of the best crafting supplies I've purchased recently.",

    "Very smooth finish and excellent workmanship on the product.",

    "The product has become an essential part of my jewellery-making toolkit.",

    "Beautiful quality and reliable performance. The product is highly recommended.",

    "The product is attractive, durable, and perfect for creative projects.",

    "The quality of the product is remarkable. Very pleased with the purchase.",

    "I enjoyed working with the product. It made my jewellery look premium.",

    "The product is exactly what every jewellery creator needs. Excellent product.",

    "Excellent quality! The exceeded my expectations.",

    "Very satisfied with the product. Will definitely order again.",

    "Amazing quality product. Worth buying.",

    "The is exactly as described.",

    "Packaging was excellent and the arrived safely.",

    "Beautiful finish on the product.",

    "Perfect for jewellery making projects.",

    "Really impressed with the quality of the product.",

    "Professional quality product.",

    "The looks even better than the photos.",

    "Highly recommended for jewellery makers.",

    "Excellent value for money."

    ],
    hinglishReviews: [

    "Quality expected se bhi better nikli. Bilkul worth it!",
    "Packaging bahut achhi thi aur product bhi perfect condition mein mila.",
    "Main first time order kar raha tha, experience bahut accha raha.",
    "Price ke hisaab se product kaafi impressive hai.",
    "Exactly wahi mila jo photos mein dikhaya gaya tha.",
    "Delivery fast thi aur product bhi genuine laga.",
    "Crafting ke liye perfect choice hai. Recommend karunga.",
    "Material ki finishing dekhkar kaafi khushi hui.",
    "Color aur quality dono hi mast hain.",
    "Is price range mein itna accha product expect nahi kiya tha.",
    "Jewellery making ke liye best option laga mujhe.",
    "Sab pieces properly packed the, kuch bhi missing nahi tha.",
    "Product use karne ke baad aur bhi order karne ka mann hua.",
    "Customer support bhi helpful tha. Thanks!",
    "Beads ka shine bahut accha hai.",
    "Mujhe quality dekhkar surprise hua. Bahut acchi hai.",
    "Photos se bhi zyada accha nikla.",
    "Order time par deliver ho gaya.",
    "DIY projects ke liye perfect product hai.",
    "Main definitely dobara purchase karunga.",
    "Product bilkul description ke according mila.",
    "Har piece ka finish kaafi clean tha.",
    "Quality consistent lagi. Bahut satisfied hoon.",
    "Beginner ho ya professional, dono ke liye useful hai.",
    "Value for money product hai. Bilkul recommend karta hoon.",
    "Mera overall experience bahut positive raha.",
    "Product use karke kaafi accha result mila.",
    "Jo expect kiya tha usse better nikla.",
    "Material durable aur premium feel deta hai.",
    "Size aur finish dono perfect nikle.",
    "Color fade hone ka koi issue nahi laga.",
    "Craft work ke liye bahut useful product hai.",
    "Seller ne packaging ka bhi achha dhyan rakha.",
    "Purchase karke bilkul regret nahi hua.",
    "Quality maintain rakhi hai, bahut accha laga.",
    "Sab kuch exactly expected jaisa tha.",
    "Affordable price mein premium quality mili.",
    "Meri jewellery project ke liye perfect raha.",
    "Product dekhte hi quality ka pata chal gaya.",
    "Finish aur detailing dono impressive hain.",
    "Delivery experience bhi smooth raha.",
    "Main apne friends ko bhi suggest karunga.",
    "Har baar ki tarah quality best mili.",
    "Is product ne meri expectation exceed kar di.",
    "Kaam karte waqt product use karna bahut easy laga.",
    "Packaging secure thi aur sab safe mila.",
    "Online order karke pehli baar itna satisfy hua.",
    "Quality aur pricing ka combination bahut accha hai.",
    "Future mein bhi isi store se order karunga.",
    "Overall experience 5 star dene layak hai.",
    "Bahut achhi quality hai. bilkul expected jaisa mila.",
        "Packaging bhi achhi thi aur ka finish superb hai.",
        "Jewellery making ke liye perfect item hai.",
        "Value for money product hai. Definitely recommend karunga.",
        "Photo me jaisa dikhaya tha, bilkul waisa hi mila.",
        "Quality expected se bhi better nikli.",
        "Delivery fast thi aur genuine hai.",
        "Kaafi premium quality hai. Dobara order karunga.",
        "Finish bahut clean hai. Happy with the purchase.",
        "Mujhe bahut pasand aaya."
        ],
    shortReviews: [
        "Nice craftsmanship.",
        "Quality is impressive.",
        "Looks exactly as shown.",
        "Very elegant.",
        "Perfect for my project.",
        "Great product.",
        "Amazing finish.",
        "Good choice.",
        "Very reliable.",
        "Nice detailing.",
        "Completely satisfied.",
        "Happy with the purchase.",
        "Nice texture.",
        "Looks premium.",
        "Easy to work with.",
        "Excellent shine.",
        "Very useful.",
        "Nice collection.",
        "Exactly what I needed.",
        "Wonderful product.",
        "Looks fantastic.",
        "Great experience.",
        "Really beautiful.",
        "Top-notch quality.",
        "Fantastic quality.",
        "Perfect size.",
        "Received in good condition.",
        "Color is beautiful.",
        "Quality is consistent.",
        "Very attractive.",
        "Simply awesome.",
        "Loved the finish.",
        "Strong and durable.",
        "Very stylish.",
        "Looks elegant.",
        "Good for jewellery making.",
        "Perfect craftsmanship.",
        "Absolutely beautiful.",
        "Amazing value.",
        "Perfectly made.",
        "Good material.",
        "Loved every piece.",
        "Very neat.",
        "Excellent appearance.",
        "Looks gorgeous.",
        "Exactly as described.",
        "Very classy.",
        "Works perfectly.",
        "Impressive quality.",
        "Neatly packed.",
        "Very convenient.",
        "Wonderful finish.",
        "Nice quality beads.",
        "Happy customer.",
        "Perfect for DIY.",
        "Very practical.",
        "Highly satisfied.",
        "Excellent material.",
        "Looks authentic.",
        "Beautiful craftsmanship.",
        "Perfect quality.",
        "Very affordable.",
        "Looks even better in person.",
        "Very well made.",
        "Good finishing touch.",
        "Elegant design.",
        "Perfect addition to my collection.",
        "Absolutely worth it.",
        "Very fine quality.",
        "Just perfect.",
        "Loved using it.",
        "Smooth finish.",
        "Excellent product quality.",
        "Very pretty.",
        "Nice workmanship.",
        "Looks durable.",
        "Perfect match.",
        "Very clean finish.",
        "Great for crafting.",
        "Good product overall.",
        "Impressive finishing.",
        "Nice buying experience.",
        "Quality is really good.",
        "Everything was perfect.",
        "Received as expected.",
        "Very lightweight.",
        "Amazing craftsmanship.",
        "Looks stunning.",
        "Very comfortable to use.",
        "Perfect for handmade jewellery.",
        "Excellent selection.",
        "Beautiful detailing.",
        "Good quality finish.",
        "Looks exactly like the photos.",
        "Very pleased.",
        "Will definitely recommend.",
        "Great quality for the price.",
        "Really satisfied.",
        "Looks amazing.",
        "Fantastic purchase.",
        "Couldn't be happier.",
        "Excellent quality!",

        "Loved the {product}!",

        "Highly recommended!",

        "Worth buying.",

        "Very nice product.",

        "Premium quality.",

        "Perfect finish.",

        "Beautiful {product}.",

        "Good packaging.",

        "Will order again.",

        "Very happy with the {product}.",

        "Excellent."

        ],

    // ==========================================================
    // Hindi Reviews
    // ==========================================================

    hindiReviews: [

    "मुझे क्वालिटी बहुत पसंद आई। शानदार प्रोडक्ट है।",
    "बिल्कुल उम्मीद के अनुसार मिला। बहुत संतुष्ट हूँ।",
    "ज्वेलरी बनाने के लिए एक बेहतरीन विकल्प।",
    "प्रोडक्ट की फिनिश बहुत साफ और आकर्षक है।",
    "इस कीमत में शानदार है।",
    "प्रोडक्ट की क्वालिटी देखकर खुशी हुई।",
    "बहुत उपयोगी है।",
    "रंग और डिजाइन दोनों शानदार हैं।",
    "ऑर्डर समय पर मिला और सुरक्षित पैकिंग में था।",
    "मटेरियल बहुत अच्छा है।",
    "मेरे DIY प्रोजेक्ट के लिए {product} बिल्कुल सही रहा।",
    "{product} इस्तेमाल करने में बहुत आसान है।",
    "पहली बार खरीदा और अनुभव शानदार रहा।",
    "{product} हर तरह से बेहतरीन निकला।",
    "मेरी उम्मीदों पर पूरी तरह खरा उतरा।",
    "क्वालिटी के मामले में {product} शानदार है।",
    "बहुत सुंदर और आकर्षक प्रोडक्ट है।",
    "ऑनलाइन खरीदे गए सबसे अच्छे प्रोडक्ट में से एक।",
    "मेरे ज्वेलरी डिज़ाइन को और खूबसूरत बना दिया।",
    "हर पीस अच्छी क्वालिटी का मिला।",
    "मैं इस से पूरी तरह संतुष्ट हूँ।",
    "प्रोडक्ट बिल्कुल फोटो जैसा ही मिला।",
    "use करने के बाद quality और भी अच्छी लगी।",
    "बहुत ही बढ़िया मटेरियल इस्तेमाल किया गया है।",
    "देखने में काफी प्रीमियम लगता है।",
    "मुझे {product} की पैकिंग भी काफी पसंद आई।",
    "मेरे सभी प्रोजेक्ट में प्रोडक्ट शानदार रहा।",
    "बहुत ही आकर्षक {product} है।",
    "{product} का रंग बिल्कुल वैसा ही है जैसा दिखाया गया था।",
    "हर बार की तरह इस बार भी {product} शानदार मिला।",
    "के साथ काम करना आसान रहा।",
    "बहुत ही शानदार खरीदारी रही।",
    "प्रोडक्ट हर पैसे की कीमत वसूल है।",
    "मेरे ग्राहकों को प्रोडक्ट बहुत पसंद आया।",
    "बहुत बढ़िया अनुभव रहा।",
    "क्वालिटी से पूरी तरह खुश हूँ।",
    "बहुत अच्छी खरीद साबित हुई।",
    "{product} ने निराश नहीं किया।",
    "बेहतरीन विकल्प है।",
    "इस का उपयोग करना आसान है।",
    "हर पीस अच्छी तरह तैयार किया गया है।",
    "जितनी उम्मीद थी उससे बेहतर मिला।",
    "मेरे लिए यह {product} एक बढ़िया खरीद रही।",
    "बहुत अच्छे अनुभव के साथ डिलीवरी मिली।",
    "बहुत अच्छी क्वालिटी का मटेरियल है।",
    "इस प्रोडक्ट से ज्वेलरी और भी सुंदर बनी।",
    "हर बार इसी को खरीदना पसंद करूँगा।",
    "लाजवाब quality है।",
    "काफी समय बाद इतना अच्छा {product} मिला।",
    "उपयोग करने के बाद बहुत संतुष्टि मिली।",
    "शानदार पैकिंग और अच्छी क्वालिटी।",
    "उम्मीद के मुताबिक बेहतरीन क्वालिटी मिली।",
    "बहुत ही शानदार अनुभव रहा।",
    "हर किसी को {product} पसंद आएगा।",
    "बहुत अच्छी खरीद साबित हुई।",
    "काफी प्रीमियम महसूस होता है।",
    "बेहतरीन डिज़ाइन और शानदार क्वालिटी।",
    "{product} की वजह से मेरा प्रोजेक्ट और सुंदर बना।",
    "बहुत ही अच्छा अनुभव रहा।",
    "{product} का उपयोग करना आसान और सुविधाजनक है।",
    "शानदार क्वालिटी वाला {product} है।",
    "सच में पसंद आया।",
    "मुझे इस {product} की quality पर पूरा भरोसा है।",
    "हर बार अच्छी क्वालिटी मिलती है।",
    "यह {product} मेरी पसंदीदा खरीदारी में से एक है।",
    "बहुत बढ़िया उत्पाद है, पूरी तरह संतुष्ट हूँ।",

    "बहुत अच्छी क्वालिटी है। उम्मीद से भी बेहतर निकला।",

    "ज्वेलरी बनाने के लिए एकदम सही है।",

    "पैसों के हिसाब से शानदार प्रोडक्ट है। दोबारा जरूर खरीदूँगा।",

    "बहुत बढ़िया फिनिश है। खरीदकर खुशी हुई।",

    "क्वालिटी शानदार है। बिल्कुल फोटो जैसा मिला।",

    "यह मेरी उम्मीदों से भी बेहतर निकला।",

    "कीमत के हिसाब से बहुत अच्छा प्रोडक्ट है।",

    "रंग और फिनिश दोनों बेहतरीन हैं।",

    "बहुत पसंद आया। फिर से जरूर खरीदूँगा।",

    "बेहतरीन क्वालिटी और शानदार पैकिंग।"

    ]

};